/* ============================================================================
   BKS — KIT DECO ASSORTI (vente complementaire couleur-assortie)
   ----------------------------------------------------------------------------
   OBJECTIF (demande proprietaire) : proposer le kit deco en COMPLEMENT de la
   housse de selle, assorti a la couleur choisie par le client — sur le meme
   principe que la mousse de guidon assortie, mais present PARTOUT (page panier,
   tiroir panier), pas seulement dans le configurateur 2D.

   PRINCIPE
   --------
   1) On lit le panier (/cart.js) et on cherche la ligne de la selle (_bks_role='base').
   2) On en extrait la COULEUR DU DESSUS. Les trois configurateurs ne nomment pas
      leurs proprietes pareil :
        - FUSION            : "Dessus" = "Violet · Simili cuir"
        - configurateur 2D  : proprietes variables
        - LA BKS (v2)       : "Descriptif" / "Matieres"
      => on balaie les proprietes par ordre de priorite et on reconnait le premier
         nom de couleur de la palette BKS. Tolerant aux accents et a la casse.
   3) On resout le kit deco assorti, DANS CET ORDRE :
        a. le kit COULEUR UNIE exacte  (ex. selle violette -> kit violet) ;
        b. a defaut, le kit BI-COLORE contenant cette couleur (ex. violette -> Turquoise/Violet) ;
        c. sinon : on n'affiche RIEN. Jamais de fausse offre.
      La resolution se fait en direct via /products/<handle>.js : un produit
      depublie renvoie 404 et disparait tout seul de l'offre. Aucun prix, aucun
      identifiant de variante n'est code en dur : tout vient du catalogue en live.
      => le jour ou les references couleur-unie sont republiees, l'assortiment
         exact reprend automatiquement, sans toucher a ce fichier.
   4) L'encart s'affiche dans la page panier et dans le tiroir. Un clic ajoute le
      kit. La ligne porte _bks_kitdeco='1' et PAS de _bks_id : elle reste donc
      detachable et bks-cart-guard.js l'ignore (ce n'est pas une piece du lot).
   5) Le kit compte dans le total qualifiant : l'ajouter rapproche des paliers
      cadeaux, et bks-gift-sync.js recalcule tout seul juste apres.

   NON NEGOCIABLE : opt-in. Rien n'est ajoute sans un clic explicite du client
   (art. 22 de la directive 2011/83/UE : aucune option payante pre-cochee).
   Si le client ferme l'encart, on ne le lui repropose plus de la session.
   ============================================================================ */
(function () {
  "use strict";
  try { if (window.__bksKitDeco) return; window.__bksKitDeco = 1; } catch (e) { return; }

  var PREFIX = "kit-deco-bks-50cc-semi-perso";

  /* Palette BKS (identique a COLORS du configurateur FUSION). cle = forme normalisee. */
  var PALETTE = ["noir", "blanc", "gris", "rouge", "orange", "jaune", "dore",
                 "vert", "turquoise", "bleu clair", "bleu", "violet", "rose"];

  /* Kit couleur UNIE : couleur -> handle. Depublies a ce jour, gardes pour le futur. */
  var UNI = {
    "blanc": PREFIX + "-blanc",
    "bleu": PREFIX + "-bleu",
    "bleu clair": PREFIX + "-bleu-clair",
    "gris": PREFIX + "-gris",
    "jaune": PREFIX + "-jaune",
    "orange": PREFIX + "-orange",
    "rose": PREFIX + "-rose",
    "turquoise": PREFIX + "-turquoise",
    "vert": PREFIX + "-vert",
    "violet": PREFIX + "-violet"
  };

  /* REPLI pour les couleurs sans kit complet assorti (noir, blanc, gris, bleu clair, dore
     = 43,6 % des selles vendues sur 12 mois). On propose alors la piece deco la plus vendue
     du catalogue (Kit Deco Carter, 16 ventes sur 12 mois, prix d'impulsion) — SANS jamais
     pretendre qu'elle est assortie, puisqu'elle ne l'est pas. Honnetete du libelle avant tout. */
  var REPLI = "kit-deco-carter";

  /* Kits BI-COLORES reellement publies. ATTENTION : le handle "-orange-jaune-copy"
     porte le titre "Orange/Vert" — on se fie aux couleurs declarees ici, pas au handle. */
  var BI = [
    { handle: PREFIX + "-bleu-rouge",        couleurs: ["bleu", "rouge"] },
    { handle: PREFIX + "-jaune-turquoise",   couleurs: ["jaune", "turquoise"] },
    { handle: PREFIX + "-orange-jaune",      couleurs: ["orange", "jaune"] },
    { handle: PREFIX + "-orange-jaune-copy", couleurs: ["orange", "vert"] },
    { handle: PREFIX + "-rose-rouge",        couleurs: ["rose", "rouge"] },
    { handle: PREFIX + "-turquoise-violet",  couleurs: ["turquoise", "violet"] },
    { handle: PREFIX + "-vert-bleu",         couleurs: ["vert", "bleu"] }
  ];

  /* --- MARQUES & MODELES 50cc couverts par BKS (selecteur de la carte upsell) ---------
     Liste EDITABLE : ajouter / retirer une marque ou un modele ici suffit, rien d'autre
     n'est a toucher dans le fichier. Aucun modele n'est invente au vol : ce tableau est
     la seule source. La puce "Autre modele" est ajoutee automatiquement a chaque marque
     pour ne jamais bloquer un client dont la moto n'est pas listee. */
  var MOTOS = [
    { marque: "Derbi",   modeles: ["Senda DRD", "Senda X-Treme", "Senda Racing", "Senda SM"] },
    { marque: "Rieju",   modeles: ["MRT", "MRT Pro", "SMX"] },
    { marque: "Beta",    modeles: ["RR 50", "RR Track", "RR SM"] },
    { marque: "Gilera",  modeles: ["SMT", "RCR"] },
    { marque: "Aprilia", modeles: ["SX 50", "RX 50"] },
    { marque: "Sherco",  modeles: ["SE-R 50", "SM-R 50"] },
    { marque: "MBK",     modeles: ["Booster", "Nitro", "Stunt", "X-Limit"] },
    { marque: "Yamaha",  modeles: ["DT 50", "TZR 50", "Aerox"] },
    { marque: "Peugeot", modeles: ["XPS", "XP6"] },
    { marque: "Piaggio", modeles: ["Zip"] },
    { marque: "Fantic",  modeles: ["XE 50", "XM 50"] },
    { marque: "KTM",     modeles: ["SX 50", "SX-E 5"] },
    { marque: "Honda",   modeles: ["Dax 50", "Monkey 50", "Vision 50"] },
    { marque: "Husqvarna", modeles: ["TC 50", "TC 65"] },
    { marque: "Kawasaki", modeles: ["KX 65", "KX 85"] },
    { marque: "GasGas",  modeles: ["MC 50", "MC 65"] },
    { marque: "Suzuki",  modeles: ["RM 65"] }
  ];
  var MOTO_AUTRE = "Autre modèle";
  /* Le choix survit aux reconstructions de la carte (le panier se rafraichit souvent). */
  var MOTO_KEY = "bks_kitdeco_moto";

  var OPTOUT = "bks_kitdeco_refus";
  /* Tags de la mecanique de remise Shopify (reduction automatique "achete une selle -> -10 %").
     TAG_SELLE conditionne la remise ; TAG_KIT et TAG_ACC designent les produits remises. */
  var TAG_SELLE = "bks-selle", TAG_KIT = "bks-kitdeco-complet", TAG_ACC = "bks-accessoire";
  var REMISE = 0.10;
  var CACHE = {};          // handle -> produit (ou null si indisponible)
  var BUSY = false, TMR = null;

  function norm(s) {
    try {
      return (s || "").toLowerCase().normalize("NFD")
        .replace(/[̀-ͯ]/g, "").replace(/\s+/g, " ").trim();
    } catch (e) { return (s || "").toLowerCase().trim(); }
  }
  function ss(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function ssSet(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }
  function euro(cents) {
    try { return (cents / 100).toFixed(2).replace(".", ",") + " €"; } catch (e) { return ""; }
  }
  /* Vignette CDN. Shopify renvoie des URL sans protocole ("//cdn.shopify.com/...") : certains
     contextes ne les chargent pas, on force donc https:. Redimensionnement via le parametre
     officiel &width= (le suffixe _200x dans le nom de fichier n'est pas fiable partout). */
  function vignette(url) {
    if (!url) return "";
    var u = String(url);
    if (u.indexOf("//") === 0) u = "https:" + u;
    return u + (u.indexOf("?") >= 0 ? "&" : "?") + "width=200";
  }

  function getCart() {
    return fetch("/cart.js", { cache: "no-cache", headers: { "Accept": "application/json" } })
      .then(function (r) { return r.json(); });
  }

  /* --- Couleur du dessus de la selle, quel que soit le configurateur d'origine --- */
  var PRIORITE = ["dessus", "couleur", "couleur dessus", "dessus de selle", "coloris",
                  "descriptif", "matieres", "matiere"];

  function couleurDepuisTexte(txt) {
    var t = norm(txt);
    if (!t) return null;
    // "bleu clair" avant "bleu" : la palette est deja ordonnee du plus specifique au plus court
    var ordre = PALETTE.slice().sort(function (a, b) { return b.length - a.length; });
    for (var i = 0; i < ordre.length; i++) {
      var c = ordre[i];
      if (new RegExp("(^|[^a-z])" + c.replace(" ", "\\s+") + "([^a-z]|$)").test(t)) return c;
    }
    return null;
  }

  /* La marque / le modele sont peut-etre DEJA connus : le configurateur de selle custom
     (bks-selle-custom-v2.js) les ecrit en proprietes de ligne. On les relit ici pour
     pre-selectionner les puces au lieu de redemander au client ce qu'il a deja saisi. */
  var MOTO_PANIER = null;
  function motoDepuisPanier(cart) {
    try {
      var items = (cart && cart.items) || [];
      var bases = items.filter(function (it) {
        return it.properties && it.properties._bks_role === "base";
      });
      var cibles = bases.length ? bases : items;
      for (var i = 0; i < cibles.length; i++) {
        var p = cibles[i].properties || {};
        var mk = p["Marque"] || p["marque"] || "";
        var md = p["Mod\u00e8le"] || p["Modele"] || p["mod\u00e8le"] || "";
        var an = p["Ann\u00e9e"] || p["Annee"] || p["ann\u00e9e"] || p["year"] || "";
        mk = String(mk || "").trim();
        if (mk) return { m: mk, x: String(md || "").trim(), a: String(an || "").trim() };
      }
    } catch (e) {}
    return null;
  }
  function couleurSelle(cart) {
    try {
      var items = (cart && cart.items) || [];
      // 1) la ligne "base" d'un configurateur, sinon n'importe quelle ligne a proprietes
      var bases = items.filter(function (it) {
        return it.properties && it.properties._bks_role === "base";
      });
      var cibles = bases.length ? bases : items;
      for (var i = 0; i < cibles.length; i++) {
        var props = cibles[i].properties || {};
        // a) proprietes prioritaires
        for (var p = 0; p < PRIORITE.length; p++) {
          for (var k in props) {
            if (!Object.prototype.hasOwnProperty.call(props, k)) continue;
            if (k.charAt(0) === "_") continue;              // proprietes techniques
            if (norm(k) !== PRIORITE[p]) continue;
            var c = couleurDepuisTexte(props[k]);
            if (c) return c;
          }
        }
        // b) a defaut, n'importe quelle propriete visible
        for (var k2 in props) {
          if (!Object.prototype.hasOwnProperty.call(props, k2)) continue;
          if (k2.charAt(0) === "_") continue;
          var c2 = couleurDepuisTexte(props[k2]);
          if (c2) return c2;
        }
      }
    } catch (e) {}
    return null;
  }

  /* --- Resolution du kit assorti (catalogue en direct, rien en dur) --- */
  function produit(handle) {
    if (Object.prototype.hasOwnProperty.call(CACHE, handle)) return Promise.resolve(CACHE[handle]);
    // cache:"no-cache" indispensable : sans lui, le navigateur peut servir une fiche produit
    // anterieure a une modification de tags ou de prix, et l'offre serait calculee sur des
    // donnees perimees (constate en test reel : les tags de remise n'etaient pas vus).
    return fetch("/products/" + handle + ".js", { cache: "no-cache", headers: { "Accept": "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (p) {
        // produit inexistant, depublie ou indisponible => pas d'offre
        if (!p || !p.available) p = null;
        CACHE[handle] = p;
        return p;
      });
  }

  function kitAssorti(couleur) {
    if (!couleur) return Promise.resolve(null);
    var uni = UNI[couleur];
    // 1) couleur unie exacte
    return (uni ? produit(uni) : Promise.resolve(null)).then(function (p) {
      if (p) return { produit: p, type: "exact", couleur: couleur };
      // 2) bi-colore contenant la couleur
      var candidats = BI.filter(function (b) { return b.couleurs.indexOf(couleur) >= 0; });
      var suite = Promise.resolve(null);
      candidats.forEach(function (c) {
        suite = suite.then(function (trouve) {
          if (trouve) return trouve;
          return produit(c.handle).then(function (pp) {
            return pp ? { produit: pp, type: "accorde", couleur: couleur } : null;
          });
        });
      });
      // 3) repli non assorti (libelle honnete, aucune promesse de couleur)
      return suite.then(function (trouve) {
        if (trouve) return trouve;
        return produit(REPLI).then(function (pp) {
          return pp ? { produit: pp, type: "repli", couleur: couleur } : null;
        });
      });
    });
  }

  /* --- Le panier contient-il une selle REELLEMENT eligible a la remise ? ---
     La remise Shopify se declenche sur le tag "bks-selle". On ne se contente donc pas d'avoir
     detecte une couleur : on verifie le tag du produit, sinon on annoncerait un -10 % qui ne
     s'appliquerait jamais au paiement. On borne a 4 lignes pour ne pas multiplier les appels. */
  function selleEligible(cart) {
    try {
      // NB : test des lignes cadeaux ecrit ici en toutes lettres. Ne PAS appeler isGift() :
      // cette fonction appartient a bks-gift-sync.js et n'existe pas dans ce module — l'appel
      // levait une ReferenceError avalee par le try/catch, et l'eligibilite retombait toujours
      // a false (donc aucune remise ne s'affichait jamais).
      var items = (cart.items || []).filter(function (it) {
        var props = it.properties || {};
        return it.handle && !props._bks_gift;
      }).slice(0, 4);
      if (!items.length) return Promise.resolve(false);
      var suite = Promise.resolve(false);
      items.forEach(function (it) {
        suite = suite.then(function (trouve) {
          if (trouve) return true;
          // fetch direct : produit() ecarte les produits indisponibles, or une selle deja au panier
          // peut l'etre devenue sans que cela change son eligibilite a la remise.
          return fetch("/products/" + it.handle + ".js", { cache: "no-cache", headers: { "Accept": "application/json" } })
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (p) { return !!(p && (p.tags || []).indexOf(TAG_SELLE) >= 0); })
            .catch(function () { return false; });
        });
      });
      return suite;
    } catch (e) { return Promise.resolve(false); }
  }
  /* Le produit propose est-il dans une collection remisee ? (kit complet ou accessoire) */
  function estRemise(p) {
    try {
      var t = p.tags || [];
      return t.indexOf(TAG_KIT) >= 0 || t.indexOf(TAG_ACC) >= 0;
    } catch (e) { return false; }
  }

  function dejaAuPanier(cart) {
    try {
      return (cart.items || []).some(function (it) {
        var p = it.properties || {};
        if (p._bks_kitdeco) return true;
        return /kit-deco/i.test(it.handle || "") || /kit\s*d[ée]co/i.test(it.product_title || "");
      });
    } catch (e) { return false; }
  }

  /* --- Ajout au panier --- */
  function ajouter(variantId, couleur, type, moto) {
    var props = { "_bks_kitdeco": "1" };
    /* Marque + modele choisis dans les bandes defilantes de la carte. Propriete VISIBLE
       (pas de "_" en tete) : elle apparait dans le panier, sur la commande et dans les
       emails. Facultative : si le client n'a rien choisi, on n'ecrit rien du tout. */
    if (moto) { try { props["Moto"] = String(moto).slice(0, 120); } catch (e) {} }
    // on n'inscrit "Assorti a" que si la couleur correspond vraiment (jamais sur un repli)
    if (couleur && type !== "repli") {
      props["Assorti à"] = couleur.charAt(0).toUpperCase() + couleur.slice(1);
    }
    return fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: props }] })
    }).then(function (r) {
      if (!r.ok) throw new Error("ajout refuse");
      // bks-gift-sync.js voit passer /cart/add.js et recalcule les paliers cadeaux tout seul
      try { document.dispatchEvent(new CustomEvent("cart:refresh")); } catch (e) {}
      return r;
    });
  }

  /* --- Encart --- */
  var CSS = [
    /* Defense en profondeur (03/09/2026) : le corps du tiroir est une grille CSS ; un item overflow:hidden
       (la barre cadeau .bks-bar3) voit sa rangee ecrasee a sa hauteur minimale quand le contenu depasse
       le tiroir, et deborde alors SUR cet encart. Le correctif principal vit dans bks-shipping-bar.liquid ;
       on le repete ici pour que l'encart reste protege meme si le snippet est un jour reverte. */
    "cart-drawer.cart-drawer::part(body){grid-auto-rows:max-content}",
    ".bks-kd{--kd-a:#8b5cf6;--kd-d:#6d28d9;font-family:'Montserrat',-apple-system,BlinkMacSystemFont,'Segoe UI',Roboto,sans-serif;",
    "background:#fff;border:1.5px solid var(--kd-a);border-radius:14px;padding:14px;margin:16px 0;display:flex;gap:14px;",
    "align-items:center;position:relative;box-shadow:0 3px 14px rgba(109,40,217,.10);box-sizing:border-box}",
    ".bks-kd *{box-sizing:border-box}",
    /* variante avec remise : cadre plus affirme, on veut que ca accroche */
    ".bks-kd--promo{border-width:2px;border-color:var(--kd-d);box-shadow:0 6px 22px rgba(109,40,217,.18)}",
    ".bks-kd__media{position:relative;flex:0 0 88px;width:88px}",
    ".bks-kd__img{width:88px;height:88px;border-radius:10px;object-fit:cover;background:#f4f0ff;display:block}",
    ".bks-kd__off{position:absolute;top:-8px;left:-8px;z-index:2;background:#e2231a;color:#fff;font-size:12px;font-weight:900;",
    "letter-spacing:.2px;padding:5px 8px;border-radius:999px;line-height:1;box-shadow:0 3px 10px rgba(226,35,26,.42);white-space:nowrap}",
    ".bks-kd__body{flex:1;min-width:0;display:flex;flex-direction:column;gap:5px}",
    ".bks-kd__tag{display:inline-block;align-self:flex-start;background:var(--kd-d);color:#fff;font-size:10.5px;font-weight:800;",
    "letter-spacing:.4px;text-transform:uppercase;padding:3px 8px;border-radius:999px;line-height:1.2}",
    ".bks-kd__t{font-size:15px;font-weight:800;color:#1b0e38;margin:0;line-height:1.3}",
    ".bks-kd__p{font-size:12.5px;color:#5b5170;margin:0;line-height:1.4}",
    /* la phrase qui porte l'argument : c'est SA selle qui debloque la remise */
    ".bks-kd__unlock{margin:4px 0 0;font-size:12.5px;line-height:1.4;color:#166534;background:#e9f9ee;",
    "border:1px solid #bbe7c8;border-radius:8px;padding:7px 10px}",
    ".bks-kd__unlock b{color:#0f5132;font-weight:800}",
    ".bks-kd__row{display:flex;align-items:center;gap:12px;flex-wrap:wrap;margin-top:7px}",
    ".bks-kd__prices{display:flex;align-items:baseline;gap:8px;flex-wrap:wrap}",
    ".bks-kd__old{font-size:14px;color:#9a93ab;text-decoration:line-through}",
    ".bks-kd__price{font-size:21px;font-weight:900;color:var(--kd-d);line-height:1}",
    ".bks-kd__eco{font-size:11.5px;font-weight:700;color:#166534;background:#e9f9ee;padding:2px 7px;border-radius:999px;white-space:nowrap}",
    ".bks-kd__btn{background:var(--kd-a);color:#fff;border:0;font-family:inherit;font-weight:800;font-size:13px;",
    "letter-spacing:.3px;text-transform:uppercase;padding:12px 18px;border-radius:9px;cursor:pointer;line-height:1.2;",
    "transition:filter .15s ease,transform .12s ease}",
    ".bks-kd__btn:hover{filter:brightness(1.08)}",
    ".bks-kd__btn:active{transform:translateY(1px)}",
    ".bks-kd__btn[disabled]{opacity:.6;cursor:default}",
    ".bks-kd__x{position:absolute;top:7px;right:9px;background:none;border:0;font-size:19px;line-height:1;color:#b3a9c9;",
    "cursor:pointer;padding:2px 5px;border-radius:6px}",
    ".bks-kd__x:hover{color:#6d28d9;background:#f4f0ff}",
    /* --- Selecteur MARQUE + MODELE : bandes defilantes (scroll-snap) ---
       Additif : n'altere ni la vignette assortie, ni les prix, ni le bouton. */
    ".bks-kd__moto{margin:9px 0 0;padding-top:9px;border-top:1px dashed #e6dffb}",
    ".bks-kd__moto-lbl{margin:0 0 6px;font-size:12px;font-weight:800;color:#1b0e38;line-height:1.35}",
    ".bks-kd__moto-lbl span{font-weight:600;color:#7c7391}",
    ".bks-kd__band{display:flex;gap:7px;overflow-x:auto;overflow-y:hidden;scroll-snap-type:x proximity;",
    "-webkit-overflow-scrolling:touch;scrollbar-width:thin;padding:4px 4px 7px;margin:0 -4px}",
    /* display:flex ecrase la regle navigateur [hidden]{display:none} : on la retablit */
    ".bks-kd__band[hidden],.bks-kd__moto-pick[hidden]{display:none}",
    ".bks-kd__band::-webkit-scrollbar{height:4px}",
    ".bks-kd__band::-webkit-scrollbar-thumb{background:#d9cffa;border-radius:999px}",
    ".bks-kd__chip{flex:0 0 auto;scroll-snap-align:center;background:#f7f4ff;border:1.5px solid #e3d9fb;",
    "color:#3b2a63;font-family:inherit;font-size:12.5px;font-weight:700;line-height:1;padding:9px 13px;",
    "border-radius:999px;cursor:pointer;white-space:nowrap;",
    "transition:background .14s ease,border-color .14s ease,color .14s ease}",
    ".bks-kd__chip:hover{background:#efe8ff;border-color:#c9b6f7}",
    ".bks-kd__chip:focus-visible{outline:2px solid var(--kd-d);outline-offset:2px}",
    ".bks-kd__chip.is-on{background:var(--kd-d);border-color:var(--kd-d);color:#fff}",
    ".bks-kd__band--mod .bks-kd__chip{background:#fff;border-style:dashed}",
    ".bks-kd__band--mod .bks-kd__chip.is-on{background:var(--kd-a);border-color:var(--kd-a);border-style:solid;color:#fff}",
    ".bks-kd__band--year .bks-kd__chip{background:#fff;border-style:dashed}",
    ".bks-kd__band--year .bks-kd__chip.is-on{background:var(--kd-a);border-color:var(--kd-a);border-style:solid;color:#fff}",
    /* incitation douce tant qu'aucune marque n'est choisie — jamais bloquante */
    ".bks-kd__band--todo .bks-kd__chip{animation:bks-kd-pulse 2.4s ease-in-out infinite}",
    "@keyframes bks-kd-pulse{0%,100%{box-shadow:0 0 0 0 rgba(139,92,246,0)}",
    "50%{box-shadow:0 0 0 3px rgba(139,92,246,.16)}}",
    "@media (prefers-reduced-motion:reduce){.bks-kd__band--todo .bks-kd__chip{animation:none}}",
    ".bks-kd__moto-pick{margin:5px 0 0;font-size:12px;font-weight:700;color:var(--kd-d);line-height:1.35}",
    "@media (max-width:560px){.bks-kd__moto-lbl{font-size:13px}",
    ".bks-kd__chip{font-size:13.5px;padding:11px 15px}.bks-kd__moto-pick{font-size:13px}}",
    /* --- Mobile : l'offre doit occuper l'ecran, pas se tasser dans un coin --- */
    "@media (max-width:560px){",
    ".bks-kd{gap:11px;padding:11px;margin:12px 0;border-radius:12px;align-items:flex-start}",
    ".bks-kd__media{flex:0 0 58px;width:58px}",
    ".bks-kd__img{width:58px;height:58px;border-radius:9px}",
    ".bks-kd__off{top:-7px;left:-7px;font-size:10px;padding:3px 6px}",
    ".bks-kd__tag{font-size:9.5px;padding:2px 7px}",
    ".bks-kd__t{font-size:13.5px}",
    ".bks-kd__p{font-size:11.5px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}",
    ".bks-kd__unlock{font-size:11px;padding:5px 9px;margin-top:3px}",
    ".bks-kd__row{gap:9px;margin-top:6px}",
    ".bks-kd__prices{flex:0 1 auto}",
    ".bks-kd__price{font-size:18px}",
    ".bks-kd__old{font-size:12.5px}",
    ".bks-kd__eco{font-size:10px;padding:2px 6px}",
    ".bks-kd__btn{flex:1 1 auto;padding:10px 12px;font-size:12px}",
    ".bks-kd__x{top:6px;right:7px;font-size:18px}",
    ".bks-kd__moto{margin-top:7px;padding-top:7px}",
    "}"
  ].join("");

  function styles() {
    if (document.getElementById("bks-kd-css")) return;
    var s = document.createElement("style");
    s.id = "bks-kd-css"; s.textContent = CSS;
    document.head.appendChild(s);
  }

  /* --- Selecteur MARQUE puis MODELE, en bandes defilantes -----------------------------
     Purement additif : il ne touche NI a la detection de couleur, NI a la resolution du
     kit assorti, NI a la vignette. Bande 1 = marques ; au clic, la bande 2 se remplit
     avec les modeles de cette marque.
     Retourne { el, valeur } ; valeur() rend "Derbi Senda DRD", "Derbi" (marque seule)
     ou "" si le client n'a rien choisi — l'ajout au panier reste possible dans tous les cas. */
  function selecteurMoto() {
    var marqueChoisie = "", modeleChoisi = "", anneeChoisie = "";

    var wrap = document.createElement("div");
    wrap.className = "bks-kd__moto";
    wrap.setAttribute("data-bks-kd-moto", "1");

    var lbl = document.createElement("p");
    lbl.className = "bks-kd__moto-lbl";
    lbl.appendChild(document.createTextNode("Ta moto "));
    var sp = document.createElement("span");
    sp.textContent = "— facultatif, on le note sur ta commande";
    lbl.appendChild(sp);

    var bandeM = document.createElement("div");
    bandeM.className = "bks-kd__band bks-kd__band--todo";
    bandeM.setAttribute("role", "group");
    bandeM.setAttribute("aria-label", "Choisis la marque de ta moto");

    var bandeMod = document.createElement("div");
    bandeMod.className = "bks-kd__band bks-kd__band--mod";
    bandeMod.setAttribute("role", "group");
    bandeMod.setAttribute("aria-label", "Choisis le modèle de ta moto");
    bandeMod.hidden = true;

    var bandeAn = document.createElement("div");
    bandeAn.className = "bks-kd__band bks-kd__band--year";
    bandeAn.setAttribute("role", "group");
    bandeAn.setAttribute("aria-label", "Choisis l'année de ta moto");
    bandeAn.hidden = true;

    var recap = document.createElement("p");
    recap.className = "bks-kd__moto-pick";
    recap.setAttribute("aria-live", "polite");
    recap.hidden = true;

    function valeur() {
      if (!marqueChoisie) return "";
      if (!modeleChoisi) return marqueChoisie;
      var base = (modeleChoisi === MOTO_AUTRE)
        ? (marqueChoisie + " — autre modèle")
        : (marqueChoisie + " " + modeleChoisi);
      if (anneeChoisie) base += " (" + anneeChoisie + ")";
      return base;
    }

    function majRecap() {
      if (!marqueChoisie) { recap.hidden = true; recap.textContent = ""; return; }
      recap.hidden = false;
      if (!modeleChoisi) { recap.textContent = "Moto : " + marqueChoisie + " — choisis ton modèle"; return; }
      if (!anneeChoisie) { recap.textContent = "Moto : " + valeur() + " — choisis l'année"; return; }
      recap.textContent = "Moto : " + valeur();
    }

    /* Le panier se rafraichit souvent (quantite, cadeaux, sync) et la carte est alors
       reconstruite : sans memoire, le client perdrait son choix en cours de route.
       On le garde le temps de la session, comme l'opt-out de la carte. */
    function memoriser() {
      ssSet(MOTO_KEY, JSON.stringify({ m: marqueChoisie, x: modeleChoisi, a: anneeChoisie }));
    }

    /* Une puce = un vrai <button> : focusable, actionnable au clavier, etat expose
       via aria-pressed (et pas seulement par la couleur). */
    function puce(texte, bande, auClic) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "bks-kd__chip";
      b.setAttribute("aria-pressed", "false");
      b.textContent = texte;
      b.addEventListener("click", function () {
        Array.prototype.slice.call(bande.querySelectorAll(".bks-kd__chip")).forEach(function (o) {
          o.classList.remove("is-on");
          o.setAttribute("aria-pressed", "false");
        });
        b.classList.add("is-on");
        b.setAttribute("aria-pressed", "true");
        // recentrer la puce choisie dans sa bande, sans faire defiler la page
        try { b.scrollIntoView({ block: "nearest", inline: "center", behavior: "smooth" }); } catch (e) {}
        auClic(texte);
      });
      bande.appendChild(b);
      return b;
    }

    /* Fleches gauche/droite : la navigation clavier suit l'ordre visuel de la bande. */
    function clavier(bande) {
      bande.addEventListener("keydown", function (ev) {
        if (ev.key !== "ArrowRight" && ev.key !== "ArrowLeft") return;
        var puces = Array.prototype.slice.call(bande.querySelectorAll(".bks-kd__chip"));
        var i = puces.indexOf(document.activeElement);
        if (i < 0) return;
        var j = i + (ev.key === "ArrowRight" ? 1 : -1);
        if (j < 0 || j >= puces.length) return;
        ev.preventDefault();
        puces[j].focus();
      });
    }
    clavier(bandeM); clavier(bandeMod); clavier(bandeAn);

    /* Bande ANNEE : proposee des qu'un modele est choisi. Les annees ne sont PAS
       specifiques au modele (BKS n'a pas cette donnee, on n'invente rien) : liste
       d'annees reelles, generee dynamiquement, + un repli "2003 et avant". Le but est
       d'inscrire l'annee sur la commande pour identifier le bon kit. */
    function anneesDispo() {
      var out = [], y;
      try { y = new Date().getFullYear(); } catch (e) { y = 2026; }
      if (!(y >= 2005 && y <= 2100)) y = 2026;
      for (var a = y; a >= 2004; a--) out.push(String(a));
      out.push("2003 et avant");
      return out;
    }
    function remplirAnnees() {
      bandeAn.textContent = "";
      anneesDispo().forEach(function (an) {
        puce(an, bandeAn, function (v) { anneeChoisie = v; majRecap(); memoriser(); });
      });
      bandeAn.hidden = false;
      try { bandeAn.scrollLeft = 0; } catch (e) {}
    }

    function remplirModeles(marque) {
      bandeMod.textContent = "";
      var entree = null;
      for (var i = 0; i < MOTOS.length; i++) {
        if (MOTOS[i].marque === marque) { entree = MOTOS[i]; break; }
      }
      var liste = (entree ? entree.modeles : []).concat([MOTO_AUTRE]);
      liste.forEach(function (m) {
        puce(m, bandeMod, function (v) { modeleChoisi = v; anneeChoisie = ""; remplirAnnees(); majRecap(); memoriser(); });
      });
      bandeMod.hidden = false;
      try { bandeMod.scrollLeft = 0; } catch (e) {}
    }

    MOTOS.forEach(function (e) {
      puce(e.marque, bandeM, function (v) {
        if (v === marqueChoisie) return;
        marqueChoisie = v;
        modeleChoisi = "";
        anneeChoisie = "";
        bandeAn.hidden = true; bandeAn.textContent = "";
        bandeM.classList.remove("bks-kd__band--todo");
        remplirModeles(v);
        majRecap();
        memoriser();
      });
    });

    /* Rejoue le choix memorise en cliquant les puces : un seul chemin de code, donc
       aucun risque de divergence entre l'etat visuel et la valeur envoyee au panier.
       wrap n'est pas encore dans le document ici : les scrollIntoView sont sans effet. */
    (function restaurer() {
      var brut = ss(MOTO_KEY);
      var v = null;
      if (brut) { try { v = JSON.parse(brut); } catch (e) { v = null; } }
      /* Rien en session : on retombe sur la moto deja saisie au panier (le client
         ne ressaisit pas ce qu'il a deja donne). */
      if (!v || !v.m) v = MOTO_PANIER;
      if (!v || !v.m) return;
      var pm = null, pms = bandeM.querySelectorAll(".bks-kd__chip");
      for (var i = 0; i < pms.length; i++) { if (pms[i].textContent === v.m) { pm = pms[i]; break; } }
      if (!pm) return;
      pm.click();                                   // remplit aussi la bande des modeles
      if (!v.x) return;
      var pmods = bandeMod.querySelectorAll(".bks-kd__chip");
      for (var j = 0; j < pmods.length; j++) {
        if (pmods[j].textContent === v.x) {
          pmods[j].click();
          if (v.a) {
            var pans = bandeAn.querySelectorAll(".bks-kd__chip");
            for (var k = 0; k < pans.length; k++) { if (pans[k].textContent === v.a) { pans[k].click(); break; } }
          }
          return;
        }
      }
    })();

    wrap.appendChild(lbl);
    wrap.appendChild(bandeM);
    wrap.appendChild(bandeMod);
    wrap.appendChild(bandeAn);
    wrap.appendChild(recap);
    return { el: wrap, valeur: valeur };
  }

  function construire(offre) {
    var p = offre.produit;
    var v = (p.variants || []).filter(function (x) { return x.available; })[0];
    if (!v) return null;
    var couleurAff = offre.couleur.charAt(0).toUpperCase() + offre.couleur.slice(1);

    var box = document.createElement("div");
    box.className = "bks-kd" + (offre.remise ? " bks-kd--promo" : "");
    box.setAttribute("data-bks-kd", "1");

    // pastille de remise, posee sur la vignette : c'est le premier element que l'oeil accroche
    var media = document.createElement("div"); media.className = "bks-kd__media";
    if (offre.remise) {
      var pastille = document.createElement("span");
      pastille.className = "bks-kd__off";
      pastille.textContent = "−10 %";
      media.appendChild(pastille);
    }

    var img = document.createElement("img");
    img.className = "bks-kd__img";
    // PAS de loading="lazy" : sur une image inseree dynamiquement apres le chargement de la page,
    // le navigateur ne declenche pas toujours le chargement differe et la vignette reste vide
    // (constate en test reel). Une vignette de 200 px ne justifie pas ce risque.
    img.decoding = "async";
    img.width = 200; img.height = 200;
    img.alt = p.title || "Kit déco BKS";
    img.src = vignette(p.featured_image);

    var body = document.createElement("div"); body.className = "bks-kd__body";
    var tag = document.createElement("span"); tag.className = "bks-kd__tag";
    var t = document.createElement("p"); t.className = "bks-kd__t";
    var d = document.createElement("p"); d.className = "bks-kd__p";

    if (offre.type === "exact") {
      tag.textContent = "Assorti à ta selle";
      t.textContent = "Complète ta selle avec le kit déco " + couleurAff;
      d.textContent = "Le kit déco " + couleurAff + " reprend exactement la couleur de ta housse : ta 50 est raccord, "
                    + "de la selle aux carénages.";
    } else if (offre.type === "accorde") {
      tag.textContent = "Accordé à ta selle " + couleurAff;
      t.textContent = "Complète ta selle avec le kit déco";
      d.textContent = p.title + " — le " + couleurAff.toLowerCase() + " de ta housse s'y retrouve. "
                    + "Pose à froid, en quelques minutes.";
    } else {
      // repli : aucune promesse d'assortiment, c'est une piece deco a part entiere
      tag.textContent = "Petit plus déco";
      t.textContent = "Ajoute le kit déco carter";
      d.textContent = "La pièce déco la plus prise par les clients BKS. "
                    + "Le kit déco complet n'existe pas encore en " + couleurAff.toLowerCase() + ".";
    }

    /* Selecteur marque + modele. Construit ICI pour etre disponible dans le gestionnaire
       de clic ci-dessous ; il est insere plus bas, juste avant la ligne prix + bouton. */
    var moto = selecteurMoto();

    var row = document.createElement("div"); row.className = "bks-kd__row";
    var zonePrix = document.createElement("div"); zonePrix.className = "bks-kd__prices";

    if (offre.remise) {
      // -10 % reellement applique par Shopify (reduction automatique liee a la selle du panier)
      var remise = Math.round(v.price * (1 - REMISE));
      var barre = document.createElement("span"); barre.className = "bks-kd__old";
      barre.textContent = euro(v.price);
      var neuf = document.createElement("span"); neuf.className = "bks-kd__price";
      neuf.textContent = euro(remise);
      var eco = document.createElement("span"); eco.className = "bks-kd__eco";
      eco.textContent = "tu économises " + euro(v.price - remise);
      zonePrix.appendChild(barre); zonePrix.appendChild(neuf); zonePrix.appendChild(eco);
    } else {
      var seul = document.createElement("span"); seul.className = "bks-kd__price";
      seul.textContent = euro(v.price);
      zonePrix.appendChild(seul);
    }

    var btn = document.createElement("button"); btn.type = "button"; btn.className = "bks-kd__btn";
    btn.textContent = "Ajouter à ma commande";

    btn.addEventListener("click", function () {
      if (btn.disabled) return;
      btn.disabled = true; btn.textContent = "Ajout…";
      /* Non bloquant : si rien n'a ete choisi, moto.valeur() rend "" et l'ajout se fait
         quand meme, simplement sans la propriete "Moto". */
      ajouter(v.id, offre.couleur, offre.type, moto.valeur()).then(function () {
        btn.textContent = "Ajouté ✓";
        setTimeout(function () { try { box.remove(); } catch (e) {} }, 900);
      }).catch(function () {
        btn.disabled = false; btn.textContent = "Ajouter à ma commande";
      });
    });

    var x = document.createElement("button");
    x.type = "button"; x.className = "bks-kd__x"; x.setAttribute("aria-label", "Masquer cette suggestion");
    x.innerHTML = "&times;";
    x.addEventListener("click", function () { ssSet(OPTOUT, "1"); try { box.remove(); } catch (e) {} });

    row.appendChild(zonePrix); row.appendChild(btn);
    body.appendChild(tag); body.appendChild(t); body.appendChild(d);

    /* L'argument central : ce n'est pas une promo generique, c'est SA selle qui debloque la remise.
       On ne l'affiche que si la remise s'appliquera vraiment (selle eligible + produit remisable). */
    if (offre.remise) {
      var deblo = document.createElement("p");
      deblo.className = "bks-kd__unlock";
      deblo.innerHTML = "<b>−10 % débloqué</b> par la selle dans ton panier — déjà déduit ci-dessous.";
      body.appendChild(deblo);
    }
    body.appendChild(moto.el);
    body.appendChild(row);
    media.appendChild(img);
    box.appendChild(media); box.appendChild(body); box.appendChild(x);
    return box;
  }

  /* Emplacements : page panier (sous la barre de progression) et tiroir panier.
     ATTENTION : la barre de progression n'a PAS la classe "bks-shipping-bar" (c'est le nom du
     snippet Liquid, pas celui du noeud rendu). Le noeud reel porte la classe "bks-bar3" et
     l'attribut data-bks-ship3 — c'est lui qu'il faut viser dans le tiroir. Sur la page panier,
     main-cart.liquid enveloppe le rendu dans .bks-cart-page-bar, qu'on utilise directement. */
  function ancres() {
    var out = [];
    var page = document.querySelector(".bks-cart-page-bar");
    if (page && page.parentNode) out.push({ noeud: page, mode: "apres" });
    var tiroirs = document.querySelectorAll("cart-drawer, .cart-drawer, #cart-drawer");
    var mobile = false;
    try { mobile = window.matchMedia("(max-width:560px)").matches; } catch (e) {}
    Array.prototype.slice.call(tiroirs).forEach(function (t) {
      var barre = t.querySelector("[data-bks-ship3], .bks-bar3");
      var pied = t.querySelector(".cart-drawer__footer");
      // Mobile (retour Micka 31/08) : encart place TOUT EN BAS, juste avant le pied
      // (bouton commande), pour laisser voir les articles du panier en premier.
      // Desktop : sous la barre cadeau, comme avant (l'espace ne manque pas).
      if (mobile && pied && pied.parentNode) { out.push({ noeud: pied, mode: "avant" }); return; }
      if (barre && barre.parentNode) { out.push({ noeud: barre, mode: "apres" }); return; }
      if (pied && pied.parentNode) out.push({ noeud: pied, mode: "avant" });
    });
    if (!out.length) {
      var repli = document.querySelector("form.cart-page, .cart-drawer__footer, cart-drawer form");
      if (repli) out.push({ noeud: repli, mode: "avant" });
    }
    return out;
  }

  function nettoyer() {
    Array.prototype.slice.call(document.querySelectorAll("[data-bks-kd]")).forEach(function (n) {
      try { n.remove(); } catch (e) {}
    });
  }

  function rendre() {
    if (BUSY) return; BUSY = true;
    if (ss(OPTOUT) === "1") { BUSY = false; return; }
    getCart().then(function (cart) {
      if (!cart || !cart.items || !cart.items.length) { nettoyer(); BUSY = false; return; }
      if (dejaAuPanier(cart)) { nettoyer(); BUSY = false; return; }
      MOTO_PANIER = motoDepuisPanier(cart);
      var couleur = couleurSelle(cart);
      if (!couleur) { nettoyer(); BUSY = false; return; }
      return kitAssorti(couleur).then(function (offre) {
        nettoyer();
        if (!offre) { BUSY = false; return; }          // aucune fausse offre
        var cibles = ancres();
        if (!cibles.length) { BUSY = false; return; }
        // On n'annonce le -10 % que s'il s'appliquera VRAIMENT : selle eligible au panier
        // ET produit propose appartenant a une collection remisee. Sinon, prix normal seul.
        return selleEligible(cart).then(function (eligible) {
          var remisable = estRemise(offre.produit);
          offre.remise = !!(eligible && remisable);
          // trace de diagnostic : permet de comprendre en une ligne pourquoi l'offre est
          // affichee avec ou sans remise, sans avoir a instrumenter le fichier a chaud.
          try {
            window.__bksKitDecoDebug = {
              selleEligible: eligible, produitRemisable: remisable, remiseAffichee: offre.remise,
              type: offre.type, handle: (offre.produit || {}).handle,
              tags: (offre.produit || {}).tags
            };
          } catch (e) {}
          poser(offre, cibles);
        });
      });
    }).catch(function () { BUSY = false; });
  }

  function poser(offre, cibles) {
    try {
      styles();
      cibles.forEach(function (a) {
        var el = construire(offre);
        if (!el) return;
        if (a.mode === "apres") a.noeud.parentNode.insertBefore(el, a.noeud.nextSibling);
        else a.noeud.parentNode.insertBefore(el, a.noeud);
      });
    } catch (e) {}
    BUSY = false;
  }

  function planifier() { if (TMR) clearTimeout(TMR); TMR = setTimeout(rendre, 350); }

  /* Le panier bouge (ajout, retrait, quantite, cadeaux) -> on re-evalue l'offre. */
  var RX = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/i;
  try {
    var of = window.fetch;
    if (typeof of === "function") {
      window.fetch = function (input) {
        var url = "";
        try { url = (typeof input === "string") ? input : (input && input.url) || ""; } catch (e) {}
        return of.apply(this, arguments).then(function (res) {
          if (RX.test(url)) planifier();
          return res;
        });
      };
    }
  } catch (e) {}
  ["cart:updated", "cart:refresh", "cart:change", "bks:gift-sync"].forEach(function (ev) {
    document.addEventListener(ev, planifier);
  });
  window.addEventListener("pageshow", planifier);
  // Rotation / redimensionnement qui franchit le point de rupture mobile <-> desktop :
  // on re-evalue pour replacer l'encart au bon endroit (bas sur mobile, haut sur desktop).
  try {
    var _mqKd = window.matchMedia("(max-width:560px)");
    if (_mqKd.addEventListener) _mqKd.addEventListener("change", planifier);
    else if (_mqKd.addListener) _mqKd.addListener(planifier);
  } catch (e) {}

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", planifier);
  else planifier();

  window.__bksKitDecoRun = rendre;   // utile pour les tests
})();
